import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const env = window.MLBBest.envVariables.ENV;

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: env !== "prod",
    lng: "en",
    fallbackLng: "en",
    backend: {
      loadPath: `/i18next/locales/{{lng}}/{{ns}}.json`,
    },
    returnObjects: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
